import { Injectable } from '@angular/core';
import { FunctionLifeCycle } from '../telephonyutils';
import { MessagingProvider } from '../telephony.provider';

@Injectable({ providedIn: 'root' })
export class IbexMessagingProvider extends MessagingProvider {
  constructor() {
    super();
  }

  init(lf: FunctionLifeCycle): void {
    lf?.onStart();

    console.log(new Date().toLocaleString() + '  ➤  Twilio Messenger');

    lf?.onEnd();
  }
  setAllMessagesRead(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]) {
    throw new Error('Method not implemented.');
  }
  sendMessage(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]) {
    throw new Error('Method not implemented.');
  }
  typing(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]) {
    throw new Error('Method not implemented.');
  }
  destroy(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]) {
    throw new Error('Method not implemented.');
  }
  getParticipantByIdentity(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]) {
    throw new Error('Method not implemented.');
  }
  sendTCPAMessage(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]) {
    throw new Error('Method not implemented.');
  }
}
